<template>
    <van-nav-bar
            title="客户信息详情"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
            style="margin-bottom: 20px"
    >
        <template #right>
            <van-tag type="warning"  v-if="void_state == 'Y'" >已作废</van-tag>
        </template>
    </van-nav-bar>
    <van-form @submit="onSubmit">
        <van-cell-group inset style="margin-bottom: 20px">
                <van-row gutter="20">
                    <van-col span="12">
                        <van-field
                                v-model="Customer_name"
                                name="Customer_name"
                                label-width="150"
                                input-align="right"
                                label="Customer Name (客户)"
                                placeholder="请输入客户名称"
                                disabled
                        />
                        <van-field v-model="date" name="date" label="Date (日期)" label-width="150" input-align="right" disabled  />
                        <van-field
                                v-model="Prepared_by"
                                name="Prepared_by"
                                label-width="150"
                                input-align="right"
                                label="Prepared by (操作人)"
                                placeholder="请输入操作人"
                                disabled
                        />
                    </van-col>
                    <van-col span="2.1">
                        <!--                    <van-divider>Business Card Uploader (名片上传)</van-divider>-->
                        <van-uploader v-model="Business_card_z" :deletable="img"  name="Business_card_z" :after-read="card_z" :max-size="5000 * 1024" @oversize="onOversize" :max-count="1" preview-size="100" upload-text="名片正面" @delete="upload_delete('z')"  style="margin-top: 20px">
                            <template #preview-cover="">
                                <div class="preview-cover van-ellipsis">名片正面</div>
                            </template>
                        </van-uploader>

                    </van-col>
                    <van-col span="2.1">
                        <van-uploader v-model="Business_card_f" :deletable="img"  name="Business_card_f" :after-read="card_f" :max-size="5000 * 1024" @oversize="onOversize" :max-count="1" preview-size="100" upload-text="名片背面" @delete="upload_delete('f')"  style="margin-top: 20px">
                            <template #preview-cover="">
                                <div class="preview-cover van-ellipsis">名片背面</div>
                            </template>
                        </van-uploader>
                    </van-col>
                </van-row>
                <van-field name="Company_character" label="Company Character(公司性质)" label-align="top" >
                    <template #input>
                        <van-checkbox-group v-model="Company_character" name="Company_character" direction="horizontal" :disabled=state>
                            <van-checkbox name="0" shape="square" style="margin-bottom: 15px"  >Distributor (经销商)</van-checkbox>
                            <van-checkbox name="1" shape="square" style="margin-bottom: 15px">Wholesaler (批发商)</van-checkbox>
                            <van-checkbox name="2" shape="square" style="margin-bottom: 15px">Retailer (零售商)</van-checkbox>
                            <van-checkbox name="3" shape="square" style="margin-bottom: 15px">Manufacturer (制造商)</van-checkbox>
                            <van-checkbox name="4" shape="square" style="margin-bottom: 15px">Import & Export (进出口)</van-checkbox>
                            <van-checkbox name="5" shape="square" style="margin-bottom: 15px">Mass Merchant (大卖场)</van-checkbox>
                            <van-checkbox name="6" shape="square" style="margin-bottom: 15px">Projects (景观工程)</van-checkbox>
                            <van-field v-model="Company_others" name="Company_others" label="Others (其他)" label-width="100" placeholder="其他性质" :readonly="state" />
                        </van-checkbox-group>

                    </template>

                </van-field>
                <van-field name="Business_line" label="Business Line(产品范围)" label-align="top" >
                    <template #input>
                        <van-checkbox-group v-model="Business_line" name="Business_line" direction="horizontal" :disabled=state>
                            <van-checkbox name="0" shape="square" style="margin-bottom: 15px">Umbrella (遮阳伞)</van-checkbox>
                            <van-checkbox name="1" shape="square" style="margin-bottom: 15px">Folding Tent (折叠篷)</van-checkbox>
                            <van-checkbox name="2" shape="square" style="margin-bottom: 15px">Pavilion (花园篷)</van-checkbox>
                            <van-checkbox name="3" shape="square" style="margin-bottom: 15px">Awning (窗篷)</van-checkbox>
                            <van-checkbox name="4" shape="square" style="margin-bottom: 15px">Pergola (凉棚）</van-checkbox>
                            <van-checkbox name="5" shape="square" style="margin-bottom: 15px">Furniture (家具)</van-checkbox>
                            <van-checkbox name="6" shape="square" style="margin-bottom: 15px">Base (伞座)</van-checkbox>
                            <van-checkbox name="7" shape="square" style="margin-bottom: 15px">Protective Cover (防尘套)</van-checkbox>
                            <van-checkbox name="8" shape="square" style="margin-bottom: 15px">Umbrella Light (伞灯)</van-checkbox>

                            <van-field v-model="Business_others" name="Business_others" label="Others (其他)" label-width="100" placeholder="其他范围" :readonly="state" />
                        </van-checkbox-group>
                    </template>
                </van-field >
            <div>
                <van-field
                        is-link
                        readonly
                        v-model="Which_country"
                        name="Which_country"
                        label="Which country (哪个国家)"
                        label-width="290"
                        input-align="right"
                        placeholder="点击选择国家"
                        @click="showArea = true"
                />
            </div>

                <van-popup
                        v-model:show="showArea"
                        position="bottom"
                        :style="{ height: '75%' }"

                >
                    <van-nav-bar title="Which country (哪个国家)"  style="position:fixed;width: 100%" />
                    <van-index-bar :sticky="false">
                        <ul v-for="vat in nation" :key="vat">
                            <van-index-anchor :index="vat" />
                            <ul v-for="vats in nationList[vat]" :key="vats">
                                <van-cell :title="vats.value" @click="Which_country = vats.value,showArea = false"/>
                            </ul>
                        </ul>
                    </van-index-bar>
                </van-popup>
                <van-field
                        name="Whether_a_group_company"
                        label="Whether a group company (是否集团公司)"
                        label-width="290"
                        input-align="right"
                        placeholder="顶部对齐"
                >
                    <template  #input>
                        <van-radio-group v-model="Whether_a_group_company" name="Whether_a_group_company" direction="horizontal" shape="square" :disabled=state>
                            <van-radio name="Y" @click="Whether_a_group_company='Y'">Yes(是)</van-radio>
                            <van-radio name="N" @click="Whether_a_group_company='N'">NO(否)</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field
                        v-model="Annual_value_of_production"
                        name="Annual_value_of_production"
                        label="Annual value of production (产值)"
                        placeholder="产值"
                        label-width="290"
                        input-align="right"
                        :readonly="state"
                />
                <van-field
                        v-model="How_many_emplovee"
                        name="How_many_emplovee"
                        label="How many emplovee (人数)"
                        label-width="290"
                        placeholder="人数"
                        input-align="right"
                        :readonly="state"
                />
                <van-field
                        v-model="Factory_area"
                        name="Factory_area"
                        label="Factory area (厂房面积)"
                        label-width="290"
                        placeholder="厂房面积"
                        input-align="right"
                        :readonly="state"
                />
                <van-field
                        v-model="Annual_purchasing_volume"
                        name="Annual_purchasing_volume"
                        label="Annual purchasing volume (年采购量)"
                        label-width="290"
                        input-align="right"
                        placeholder="年采购量"
                        :readonly="state"
                />
                <van-field
                        v-model="Product_range_pecentage"
                        name="Product_range_pecentage"
                        label="Product range(pecentage %)(产品范围,占比)"
                        placeholder="产品范围，占比"
                        label-width="290"
                        input-align="right"
                        :readonly="state"
                />
                <van-field
                        v-model="Career_experience"
                        name="Career_experience"
                        label="Career experience (行业经验)"
                        placeholder="行业经验"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />
                <van-field
                        v-model="Product_market_positioning"
                        name="Product_market_positioning"
                        label="Product market positioning (产品市场定位)"
                        placeholder="产品市场定位"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />

                <van-field
                        v-model="Sales_area"
                        name="Sales_area"
                        label="Sales area (销售区域)"
                        placeholder="销售区域"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />

                <van-field
                        v-model="Suppliers"
                        name="Suppliers"
                        label="Suppliers (供应商)"
                        placeholder="供应商"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />
                <van-field
                        v-model="Experience_with_china"
                        name="Experience_with_china"
                        label="Experience with China (做生意的经验)"
                        placeholder="做生意的经验"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />
                <van-field
                        v-model="Cooperation_intention"
                        name="Cooperation_intention"
                        label="Cooperation intention (合作意向)"
                        placeholder="合作意向"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />

                <van-field
                        v-model="Need_quotations"
                        name="Need_quotations"
                        label="Need Quotations(报价需求)"
                        placeholder="报价需求"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />
                <van-field
                        v-model="Need_samples"
                        name="Need_samples"
                        label="Need Samples(样品需求)"
                        placeholder="样品需求"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />
                <van-field
                        v-model="Other_remarks"
                        name="Other_remarks"
                        label="Other Remarks(其他备注)"
                        placeholder="其他备注"
                        label-align="top"
                        autosize
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        :readonly="state"
                />

        </van-cell-group>
        <van-button type="success" block native-type="submit" @click="img=false,state=true" style="margin-bottom: 100px">提交信息</van-button>

<!--        <van-row justify="center" v-if="void_state == 'N'">
            <van-col span="23">
                <div v-if="state">
                    <van-button type="primary" block @click="img=true,state=false" style="margin-bottom: 100px">修改资料</van-button>
                </div>
                <div v-else>
                    <van-button type="success" block native-type="submit" @click="img=false,state=true" style="margin-bottom: 100px">提交信息</van-button>
                </div>

            </van-col>
        </van-row>-->
    </van-form>
</template>
<script setup >
import {getCurrentInstance, onMounted, ref, toRaw} from "vue";
import nationList from "../json/nation";
import { showFailToast, showLoadingToast, showSuccessToast, showToast} from "vant";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import CustomerQuery from "@/components/CustomerQuery.vue";
import {useRoute} from "vue-router";
window.document.title = 'Customer Info'
const {proxy} = getCurrentInstance()
const Set_Name = [];

//国家选择框状态
const showArea = ref(false);
const void_state = ref();
/*
* 表单变量
* */
//客户名称
const Customer_name = ref('');
//时间
const date = ref(new Date().toLocaleDateString());
//操作人
const Prepared_by = ref()
//产品性质
const Company_character = ref([]);
//产品性质其他
const Company_others = ref();
//产品范围
const Business_line = ref();
//产品范围其他
const Business_others = ref();
//哪个国家
const Which_country = ref()
//是否是集团公司
const Whether_a_group_company = ref()
//产值
const Annual_value_of_production = ref()
//人数
const How_many_emplovee = ref()
//厂房面积
const Factory_area = ref()
//年采购量
const Annual_purchasing_volume = ref()
//产品范围，占比
const Product_range_pecentage = ref()
//行业经验
const Career_experience = ref()
//产品市场定位
const Product_market_positioning = ref()
//销售区域
const Sales_area = ref()
//有哪些供应商
const Suppliers = ref()
//和中国做生意的经验
const Experience_with_china = ref()
//合作意向
const Cooperation_intention = ref()
//报价需求
const Need_quotations = ref()
//样品需求
const Need_samples = ref()
//其他备注
const Other_remarks = ref()

const Business_card_z = ref([]);
const Business_card_f = ref([])
const Code_Z = ref('');
const Code_F = ref('');
const ID = ref('');

const img = ref(true);
const state = ref(false)
// eslint-disable-next-line no-unused-vars
const route = useRoute();
onMounted(() => {
    //axios.post("http://localhost:8002/lj/back/query_id",
    axios.post("https://afa.activa-leisure.com/lj/back/query_id",
        {Id: route.query.id},
        {
            headers:{
                "content-type": "application/x-www-form-urlencoded"
            }
        }
    ).then( result => {
        console.log(result)
        if (result.data.success){
            ID.value = result.data.data.id;
            Customer_name.value = result.data.data.customer_Name;
            date.value = result.data.data.date;
            void_state.value = result.data.data.state;
            Prepared_by.value = result.data.data.prepared_By;
            Company_character.value = result.data.data.company_Character.split(',');
            Company_others.value = result.data.data.company_others;
            Business_line.value = result.data.data.business_Line.split(',');
            Business_others.value = result.data.data.business_others;
            Which_country.value = result.data.data.which_Country;
            Whether_a_group_company.value = result.data.data.whether_A_Group_Company;
            Annual_value_of_production.value = result.data.data.annual_Value_Of_Production;
            How_many_emplovee.value = result.data.data.how_Many_Emplovee;
            Factory_area.value = result.data.data.factory_Area;
            Annual_purchasing_volume.value = result.data.data.annual_Purchasing_Volume;
            Product_range_pecentage.value = result.data.data.product_Range_Pecentage
            Career_experience.value = result.data.data.career_Experience
            Product_market_positioning.value = result.data.data.product_Market_Positioning
            Sales_area.value = result.data.data.sales_Area
            Suppliers.value = result.data.data.suppliers
            Experience_with_china.value = result.data.data.experience_With_China
            Cooperation_intention.value = result.data.data.cooperation_Intention
            Need_quotations.value = result.data.data.need_Quotations
            Need_samples.value = result.data.data.need_Samples
            Other_remarks.value = result.data.data.other_Remarks
            Business_card_z.value = [ {url : 'https://afa.activa-leisure.com/img/'+result.data.data.business_Card_Z}]
            Code_Z.value = result.data.data.business_Card_Z
            Business_card_f.value = [ {url : 'https://afa.activa-leisure.com/img/'+result.data.data.business_Card_F}]
            Code_F.value = result.data.data.business_Card_F
            console.log(void_state.value);
        }else {
            showFailToast(result.data.data.state)
        }
    })

   /* this.img=true;
    this.state=false;*/
})
const onOversize = (file) => {
    console.log(file);
    showToast('文件大小不能超过 5MB');
};

const onClickLeft = () => history.back();
const card_z = (file) => {
    file.status = 'uploading';
    file.message = '上传中...';
    axios.post("https://afa.activa-leisure.com/lj/back/code_upload",
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then( result =>{
        //closeToast();
        if (result.data.success){
            Object.assign(Business_card_z.value,{url : result.data.url})
            setTimeout(() => {
                file.status = 'done';
                file.message = result.data.message;
            }, 1000);
        }else {
            setTimeout(() => {
                file.status = 'failed';
                file.message = result.data.message;
            }, 1000);
        }
    })

};
const upload_delete = (after) => {
    if (after == 'z'){
        Code_Z.value = ''
    }else if (after == 'f'){
        Code_F.value = ''
    }
}
const card_f = (file) => {
    file.status = 'uploading';
    file.message = '上传中...';
    //axios.post(//"http://localhost:8002/lj/back/code_upload",
    axios.post("https://afa.activa-leisure.com/lj/back/code_upload",
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(result => {

        if (result.data.success){
            Object.assign(Business_card_f.value,{url : result.data.url})
            setTimeout(() => {
                file.status = 'done';
                file.message = result.data.message;
            }, 1000);
        }else {
            setTimeout(() => {
                file.status = 'failed';
                file.message = result.data.message;
            }, 1000);
        }
    })
}

//默认操作人员赋值
if (proxy.$cookies.get('Cell_Name') != null && proxy.$cookies.get('Cell_Name') != ''){
    Prepared_by.value = proxy.$cookies.get('Cell_Name')
}
//操作人员选择赋值
if (proxy.$cookies.get('Set_Name') != null && proxy.$cookies.get('Set_Name') != ''){
    Set_Name.value = proxy.$cookies.get('Set_Name')
    for( let i = 0 ; i < Set_Name.value.length ; i++){
        Set_Name.push(Set_Name.value[i])
    }
}

//国家排序数组
const nation = ref(["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","Y","Z"])



//提交方法
const onSubmit = (values) => {
    if (confirm('确定要提交修改吗？')) {

        console.log("1");
        console.log(values);
        const character = values.Company_character.join(',')
        console.log("1");
        console.log(character);
        const line = values.Business_line.join(',')
        console.log("1");
        console.log(line);
        if(Code_Z.value == ''){
            Code_Z.value = toRaw(Business_card_z.value).url
        }else if (Code_F.value == ''){
            Code_F.value = toRaw(Business_card_f.value).url
        }
        console.log(Business_card_z.value)
        Object.assign(values,
            { 'Company_character': character },
            { 'Business_line': line },
            { 'Business_card_z': Code_Z.value },
            { 'Business_card_f': Code_F.value },
            { 'id' : ID.value }
        )
        showLoadingToast({
            overlay:true,
            forbidClick:true,
            message: '提交中...',
            duration:0
        });
        console.log(values);
        //axios.post("http://localhost:8002/lj/back/update_customer",

        axios.post("https://afa.activa-leisure.com/lj/back/update_customer",
            values,
            {
                headers:{
                    "content-type": "application/x-www-form-urlencoded"
                }
            }
        ).then( result =>{
            // closeToast();
            setTimeout(() => {
                if (result.data.success) {
                    showSuccessToast(result.data.message);
                } else {
                    showFailToast(result.data.message);
                }
            },1000)
        })
        // console.log('submit', values);
    } else {
        // Do something else or remove this empty block
    }
};
</script>
<style>
.preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
}
</style>